








import { Component, Mixins, Emit, Watch, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../system/mixins";
import { StringFilterParameter } from "../../system/filters";
import StringFilter from "../../system/filters/StringFilter.vue";
import { FormatReferenceFilterParameter } from ".";
import { DocumentKind } from "../../../domain/document";
import DocumentKindDropDownSelector from "../../document/selectors/DocumentKindDropDownSelector.vue";
import { DomainRegistry } from "../../../domain";

@Component({
  components: {
    StringFilter,
    documentKindSelector: DocumentKindDropDownSelector,
  },
})
export default class FormatReferenceDocumentKindFilter extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: FormatReferenceFilterParameter) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: FormatReferenceFilterParameter) => T, defaultValue: T) => T;

  data(): any {
    return {
      selectDocumentKind: null as DocumentKind,
      documentKindText: "",
    };
  }
  selectDocumentKind: DocumentKind;
  documentKindText: string;

  mounted() {
    this.updateDocumentKindText();
  }

  @Watch("editingSource")
  onEditingSourceUpdated(newValue: FormatReferenceFilterParameter, oldValue: FormatReferenceFilterParameter) {
    if (!newValue || newValue.documentKinds.length === 0) {
      // 基本的に上位からパラメータを更新されることはないが、クリアされたときは空にする必要がある
      this.selectDocumentKind = null;
    }
    this.updateDocumentKindText();
  }

  get documentKind(): StringFilterParameter {
    return this.readPropertyOrDefault(s => s.documentKinds.length > 0
      ? s.documentKinds[0]
      : new StringFilterParameter("", false), new StringFilterParameter("", false));
  }

  set documentKind(source: StringFilterParameter) {
    this.writePropertyWhenValid(s => s.documentKinds = [source]);
  }

  get documentKinds(): StringFilterParameter[] {
    return this.readPropertyOrDefault(s => s.documentKinds, []);
  }

  @Watch("selectDocumentKind")
  onSelectDocumentKindUpdated(newValue: DocumentKind, oldValue: DocumentKind): void {
    const newKeyword = newValue ? newValue.id : "";
    // mounted経由で更新したとき、値自体は変わらないのにフィルター更新がかかってツリー表示と競合してエラーログが出るので対策している
    if (this.documentKind.keyword !== newKeyword) {
      this.documentKind = new StringFilterParameter(newKeyword, false);
    }
  }

  @Emit("updateText")
  async updateDocumentKindText(): Promise<string> {
    this.documentKindText = this.documentKind.keyword !== ""
      ? await Promise.all(this.documentKinds.map(v => this.toDocumentKind(v.keyword))).then(vs => vs.map(v => v.name).join(","))
      : "";
    return this.documentKindText;
  }

  private async toDocumentKind(keyword: string): Promise<DocumentKind> {
    const repository = DomainRegistry.document.getDocumentKindRepository();
    try {
      return await repository.getEntity(keyword);
    } catch {
      return new DocumentKind(keyword, "不明(ID:" + keyword + ")");
    }
  }

  @Prop({ default: true })
  isEnable: boolean;
}
